import { render, staticRenderFns } from "./GoodsSettingCustomNameStyle.vue?vue&type=template&id=11b50a74&scoped=true&"
import script from "./GoodsSettingCustomNameStyle.vue?vue&type=script&lang=js&"
export * from "./GoodsSettingCustomNameStyle.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSettingCustomNameStyle.vue?vue&type=style&index=0&id=11b50a74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b50a74",
  null
  
)

export default component.exports